import Accommodations from './Accommodations';

export default Accommodations;
